import styled from 'styled-components';

export const Button = styled.button`
  border: none;
  background: none;
  outline: none;
  font-size: 4rem;
  transition: color var(--transition);
  &:hover {
    cursor: pointer;
    color: var(--accent);
  }
`;
